var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.5H12.915C3.09 13.935 1.695 5.645 1.5 3.115C1.48429 2.91829 1.50755 2.72041 1.56844 2.53271C1.62933 2.345 1.72666 2.17115 1.85486 2.02113C1.98306 1.8711 2.13959 1.74784 2.31551 1.65842C2.49142 1.569 2.68325 1.51516 2.88 1.5H5.635C5.83528 1.49981 6.031 1.55976 6.19682 1.67208C6.36263 1.78441 6.4909 1.94394 6.565 2.13L7.325 4C7.39818 4.18177 7.41634 4.38104 7.37722 4.57305C7.33811 4.76505 7.24345 4.94134 7.105 5.08L6.04 6.155C6.20636 7.10037 6.65909 7.97183 7.33695 8.65148C8.01481 9.33112 8.88507 9.78615 9.83 9.955L10.915 8.88C11.0557 8.74308 11.2337 8.65063 11.4266 8.61417C11.6196 8.57771 11.819 8.59887 12 8.675L13.885 9.43C14.0683 9.50644 14.2246 9.63571 14.3341 9.80134C14.4437 9.96696 14.5014 10.1614 14.5 10.36V13C14.5 13.3978 14.342 13.7794 14.0607 14.0607C13.7794 14.342 13.3978 14.5 13 14.5ZM3 2.5C2.86739 2.5 2.74022 2.55268 2.64645 2.64645C2.55268 2.74022 2.5 2.86739 2.5 3V3.04C2.73 6 4.205 13 12.97 13.5C13.0357 13.5041 13.1015 13.4951 13.1638 13.4737C13.226 13.4522 13.2833 13.4187 13.3326 13.375C13.3818 13.3314 13.422 13.2784 13.4507 13.2192C13.4794 13.16 13.4962 13.0957 13.5 13.03V10.36L11.615 9.605L10.18 11.03L9.94 11C5.59 10.455 5 6.105 5 6.06L4.97 5.82L6.39 4.385L5.64 2.5H3Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone16);
export default __webpack_public_path__ + "static/media/Phone16.593466e36410d5de60e333d96b5232e2.svg";
export { ForwardRef as ReactComponent };